import React from 'react';
import { FormLabel, FormValue } from '../Form/FormLabel';
import { Button } from 'reactstrap'
import { Route, useHistory } from 'react-router-dom';
import Editor from '../Models/Editor';
import entities from '../../utils/entities';
const ClientDepartment = ({ route, clientDepartment, clientStaff }) => {
    const history = useHistory();
    const { id,departmentName, firstName, lastName, email, status, departmentPhone } = { ...clientDepartment };
    const setItemId = (id) =>
        id ? history.push(route + "/department/" + id + '/Detail') : history.push(route);

    return <React.Fragment>
        <FormLabel><Button size='sm' onClick={() => setItemId(id)} > Department({ status })</Button></FormLabel>
        <FormValue>{departmentName} </FormValue>
        {clientStaff ? null : <FormValue> {firstName} {lastName} {email}  {departmentPhone}</FormValue>}
        <Route path={route + '/department/:clientDepartmentId/:departmentAction'} render={({ match }) => <Editor route={route + '/department'} entity={entities.clientDepartment} itemId={match.params.clientDepartmentId} editorClosed={() => setItemId()} />} />

    </React.Fragment>
};
export default ClientDepartment; 